import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './styles/index.css';
import { initializeSecureLogging } from './utils/security';
import './utils/devToolsWarning';

// Initialize secure logging to prevent sensitive data exposure
initializeSecureLogging();

/*
 * Dismiss the loading screen from here, not from an inline script.
 *
 * index.html hid it with a script tag that runs on window load. Any
 * Content-Security-Policy without unsafe-inline blocks that - which is exactly
 * what this application sends when Express serves the built app rather than
 * nginx - and the overlay then covers a perfectly working page forever.
 * React mounting is the honest signal that the app is ready anyway.
 */
document.body.classList.add('loaded');

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: 'var(--surface-2)',
            color: 'var(--text-primary)',
            border: '1px solid var(--border-strong)',
            borderRadius: '8px',
            fontFamily: 'var(--font-primary)',
            fontSize: '0.9rem',
            fontWeight: '500',
          },
          success: {
            iconTheme: {
              primary: 'var(--success-color)',
              secondary: 'var(--surface-1)',
            },
          },
          error: {
            iconTheme: {
              primary: 'var(--error-color)',
              secondary: 'var(--surface-1)',
            },
          },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>
);
